import AuthenticatedAPIClient from '../lib/AuthenticatedAPIClient';

const RewardPointsService = {
    async getPointsForFare(setter, ticketType, ticketCost, purchaseDate, travelDate) {
        try {
            const response = await AuthenticatedAPIClient.post(`/reward-point/journey-reward`, {
                setter,
                ticketType,
                ticketCost,
                purchaseDate,
                travelDate,
            });

            return response;
        } catch (e) {
            console.warn('error getting reward points', e);
            return {
                points: 0,
            };
        }
    },

    async registerTicketsForReward(
        orderId,
        purchaseDate,
        hasPreferredDelivery,
        tickets,
        customerId,
        customerEmail,
    ) {
        try {
            const response = await AuthenticatedAPIClient.post(`/reward-point/customer-reward`, {
                orderId,
                purchaseDate,
                hasPreferredDelivery,
                tickets,
                customerId,
                customerEmail,
            });

            return response;
        } catch (e) {
            console.warn('error registering ticket(s) for reward points', e);
            return false;
        }
    },
};

export default RewardPointsService;
